export enum SettingsRoutes {
  root = 'settings',
  organization = 'organization',
  general = 'organization/settings/double-opt-in',
  members = 'organization/members/active',
  rolesPermissions = 'roles-permissions',
  teams = 'organization/teams',
  inboxes = 'organization/inboxes/all-inboxes',
  numbers = 'organization/numbers',
  addOns = 'organization/add-ons',
  compliance = 'organization/compliance',
  planAndBilling = 'billing/overview',
  autoRecharge = 'billing/auto-recharge',
  addSubscription = 'personal/settings/profile?add-subscription=true',

  tags = 'organization/tags',
  customFields = 'organization/custom-fields',
  urlShortener = 'organization/custom-url-shortener',
  websiteChatWidget = 'widget/chat',
  quickLinks = 'quick-links',
}
